module.exports = __webpack_public_path__ + "img/extended.0dbb95cb.png";